// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__th7r8","newExpiryDate":"styles_newExpiryDate__31k1u","footer":"styles_footer__115Hf"};